import * as Cesium from 'cesium';

function isClockwiseLngLat(coords: number[][]): boolean {
  let sum = 0;
  for (let i = 0; i < coords.length - 1; i++) {
    const [x1, y1] = coords[i];
    const [x2, y2] = coords[i + 1];
    sum += (x2 - x1) * (y2 + y1);
  }
  return sum > 0;
}


function normalizeRing(
  coords: number[][],
  clockwise: boolean
): number[][] {
  const isCW = isClockwiseLngLat(coords);
  return isCW !== clockwise ? coords.slice().reverse() : coords;
}

function ringToCartesian(coords: number[][]): Cesium.Cartesian3[] {
  return coords.map(([lng, lat]) =>
    Cesium.Cartesian3.fromDegrees(lng, lat)
  );
}

export function polygonToHierarchy(
  coords: number[][][]
): Cesium.PolygonHierarchy {

  // Outer ring MUST be CCW
  const outerLngLat = normalizeRing(coords[0], false);
  const outer = ringToCartesian(outerLngLat);

  // Holes MUST be CW
  const holes = coords.slice(1).map(holeLngLat =>
    new Cesium.PolygonHierarchy(
      ringToCartesian(
        normalizeRing(holeLngLat, true)
      )
    )
  );

  return new Cesium.PolygonHierarchy(outer, holes);
}

export function geoJsonToHierarchies(
  geojson: any
): { hierarchy: Cesium.PolygonHierarchy; properties: any }[] {

  const result: { hierarchy: Cesium.PolygonHierarchy; properties: any }[] = [];

  if (geojson.type === 'FeatureCollection') {
    geojson.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const geometry = feature.geometry;

      if (geometry.type === 'Polygon') {
        result.push({
          hierarchy: polygonToHierarchy(geometry.coordinates),
          properties: feature.properties
        });
      }

      if (geometry.type === 'MultiPolygon') {
        geometry.coordinates.forEach((coords: number[][][]) => {
          result.push({
            hierarchy: polygonToHierarchy(coords),
            properties: feature.properties
          });
        });
      }
    });

    return result;
  }

  const geometry = geojson.type === 'Feature'
    ? geojson.geometry
    : geojson;

  if (geometry.type === 'Polygon') {
    result.push({
      hierarchy: polygonToHierarchy(geometry.coordinates),
      properties: geojson.properties
    });
  }

  if (geometry.type === 'MultiPolygon') {
    geometry.coordinates.forEach((coords: number[][][]) => {
      result.push({
        hierarchy: polygonToHierarchy(coords),
        properties: geojson.properties
      });
    });
  }

  return result;
}